import { Controller } from "@hotwired/stimulus"

// "Search without saving" on the New Filter form (independent QA: a named,
// saved filter was the only way to run a search). Sends the form's criteria
// fields — not the name, sharing or the CSRF token — to the shop list as a GET,
// so the result pages and can be bookmarked like any list.
export default class extends Controller {
  static values = { url: String }

  run() {
    const form = this.element.closest("form")
    if (!form) return

    const params = new URLSearchParams()
    params.set("advanced", "1")
    for (const [name, value] of new FormData(form)) {
      if (!name.startsWith("filter[criteria]") || value === "") continue
      params.append(name, value)
    }
    window.Turbo.visit(`${this.urlValue}?${params.toString()}`)
  }
}
